export default class DefaultThemeService {
    performPostComponentMountActions() {
        return false;
    }

    performPostComponentDidUpdate() {
        return false;
    }

    scaleImage() {
        return false;
    }

    mergeSections() {
        return false;
    }

    getStimulusLayoutClassSelector() {
        return '';
    }

    shouldHideScorableItemHeadline() {
        return false;
    }

    shouldShowSectionRubric() {
        return false;
    }

    isInlineChoiceImageScalingSupported() {
        return false;
    }

    getThemeQuestionLabel() { return null; }

    addQuestionWrapperClassNames() {}

    addQuestionClassNames() {}

    addGapChoiceClassNames() {}

    getSystemPrintedVariable() {
        return '[SYSTEM_VARIABLE_NOT_SUPPORTED]';
    }

    getMainQuestionWrapperLabel(label) {
        const { questionNumberId, headerId } = label;
        return `${questionNumberId} ${headerId}`;
    }

    getQuestionRubricsContent() {
        return null;
    }

    shouldAddExtraLineSpacing() {
        return false;
    }
}
